const vouchersAltTextI18nEn = {
  'altTextVoucherImage1': 'Repair Rebels gift voucher for sustainable fashion repairs',
  'altTextVoucherImage2': 'Sustainable fashion gift voucher for clothing and shoe repairs',
};

export default vouchersAltTextI18nEn;
